import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '@portal/shared/services/alert-service';
import { Router } from '@angular/router';
import { InventoryStoreService } from '@portal/api/inventory/inventory-store.service';

@Injectable()
export class InventoryErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly _alertService: AlertService,
        private readonly _router: Router,
        private readonly _inventoryStore: InventoryStoreService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (!this.isInventoryRoute(request.url)) {
                    return throwError(() => error);
                }

                if (error.status === 400) {
                    this._alertService.error(this.extractMessage(error) || 'Validation error. Please review your input.');
                } else if (error.status === 404) {
                    this._alertService.error('Inventory resource not found.');
                    this._router.navigate(['/party/events']);
                } else if (error.status === 409) {
                    this._alertService.info('Stock changed recently; please refresh and try again.');
                    this._inventoryStore.requestRefresh();
                }

                return throwError(() => error);
            })
        );
    }

    private isInventoryRoute(url: string): boolean {
        return url.includes('/api/inventory') || /\/api\/party-events\/.+\/inventory/.test(url);
    }

    private extractMessage(error: HttpErrorResponse): string {
        if (typeof error?.error === 'string') {
            return error.error;
        }

        return error?.error?.message || error?.error?.error?.message || '';
    }
}
